<script>
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import formEmitirReceita from '@/src/components/form-emitir-receita'
import receitaService from '@/src/services/receita'
import relReceita from '@src/components/rel-receita.vue'
import { mask } from 'vue-the-mask'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'
import empresaService from '@/src/services/empresa_sistema'
import estoqueService from '@/src/services/api-receituario/estoque'

import moment from 'moment'
import * as Sentry from '@sentry/vue'
import produtorRural from '@/src/services/produtor-rural'
import agronomoService from '@/src/services/agronomo'
moment.locale('pt-br')

/**
 * Produtor rural Component
 */
export default {
  directives: { mask },
  components: {
    Layout,
    Loading,
    formEmitirReceita,
    DatePicker,
    relReceita,
  },
  data() {
    return {
      showModalEditarNumeracao: false,
      showFilterSidebar: false,
      novo_numero_receita: '',
      nova_nf: '',
      nova_serie_nf: '',
      novo_valor_nf: '',
      empresa: {},
      receita: { id: null },
      receitas: [],
      receitasExcel: [],
      mostraForm: true,
      relatorioReceita: {},
      idReceita: null,
      filterAgronomo: '',
      filterProdutor: '',
      filterDataInicial: '',
      filterDataFinal: '',

      produtores: [],
      isLoadingProdutores: false,
      produtoresTotalDisponivel: 0,
      produtorSearchDebounce: null,
      produtorAutocompleteTerm: '',
      agronomos: [],
      produtorSelecionado: {},
      agronomoSelecionado: {},
      columns: [
        {
          label: 'Receita',
          field: 'numero',
        },
        {
          label: 'Responsável',
          field: 'responsavel',
        },
        {
          label: 'Produtor',
          field: 'produtor',
        },
        {
          label: 'Emissão',
          field: 'data',
        },
        {
          label: 'Status',
          field: 'status',
        },
      ],
      receitaFields: [
        {
          key: 'numero',
          label: 'Número Receita',
        },
        {
          key: 'nf',
          label: 'NF',
        },
        {
          key: 'agronomo.nome',
          label: 'Responsável Técnico',
        },
        {
          key: 'produtor.nome',
          label: 'Produtor',
        },
        {
          key: 'data',
          label: 'Emissão',
        },
        {
          key: 'status',
          label: 'Status',
        },
        { key: 'actions', label: '' },
      ],
      status: [
        {
          status: 'INICIADA',
          descricao: 'Iniciada',
        },
        {
          status: 'EMITIDA',
          descricao: 'Emitida',
        },
        {
          status: 'CANCELADA',
          descricao: 'Cancelada',
        },
      ],
      filter: {
        numero_receita: '',
        data_inicial: '',
        data_final: '',
        status: '',
        cpfcnpj_produtor: ''
      },
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 40, 60, 100],
      showModal: false,
      isLoading: false,
      rows: 0,
      showModalReiniciar: false,
      syncingReceitaId: null,
      isIntegrationLoading: false,
      integrationLoadingMessage: '',
    }
  },
  computed: {
    currentLogin() {
      return this.$store.state.auth.currentUser.user || ''
    },
    canSyncTorgeFaturamento() {
      return this.currentLogin === 'peufalcao'
    },
    produtorAutocompleteOptions() {
      return this.produtores.map((item) => this.getProdutorOptionLabel(item))
    },
  },
  watch: {
    currentPage() {
      this.verifyAndApplyFilters();
    },
    perPage() {
      this.verifyAndApplyFilters();
    },
  },
  async mounted() {
    this.handleConsultarProdutores()
    this.handleConsultarAgronomo()

    this.$root.$on('back', () => {
      this.mostraForm = false
      this.cadastro()
    })
    this.getEmpresa()

    if (this.$store.state.auth.currentUser.user === 'cassul') {
      this.filter.status = 'EMITIDA'
      this.listandoByFilter()
      return
    }

    this.listando()
  },
  methods: {
    getEmpresa() {
      const token = this.$store.state.auth.currentUser.token
      empresaService.listarEmpresa(token).then((resposta) => {
        this.empresa = resposta.data.empresa[0]
      })
    },
    formatDate(date) {
      if (date != undefined) return moment.utc(date).format('DD/MM/YYYY')

      return '-'
    },
    loading(a) {
      a = !this.isLoading
      return a
    },
    listando() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.show)
      receitaService
        .listar(token, this.perPage, this.currentPage)
        .then((resposta) => {
          // Sentry.captureMessage(`timezone do sistema: ${tz}`);
          // Sentry.captureMessage(resposta.data.data);
          this.receitas = resposta.data.data
          this.rows = resposta.data.count

          this.receitasExcel = this.receitas.map(function (element) {
            return {
              numero: element.numero,
              responsavel: element.agronomo.nome,
              produtor: element.produtor.nome,
              data: element.data,
              status: element.status,
            }
          })

          this.isLoading = this.loading(this.show)
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    listandoByFilter() {
      console.log(this.filter)
      if (
        this.filter.numero_receita != undefined ||
        this.filter.status != undefined ||
        this.filter.data_inicial != undefined ||
        this.filter.data_final != undefined ||
        this.produtorSelecionado !== undefined ||
        this.agronomoSelecionado !== undefined ||
        this.filter.cpfcnpj_produtor !== undefined
      ) {
        const token = this.$store.state.auth.currentUser.token
        this.isLoading = this.loading(this.show)


        let idProdutorRural = this.produtorSelecionado && this.produtorSelecionado.item ? this.produtorSelecionado.item.id_produtor_rural : undefined;
        let idAgronomo = this.agronomoSelecionado && this.agronomoSelecionado.item ? this.agronomoSelecionado.item.id_agronomo : undefined;

        receitaService
          .listarByFilter(
            token,
            this.filter.numero_receita,
            this.filter.status,
            this.filter.data_inicial,
            this.filter.data_final,
            idProdutorRural,
            idAgronomo,
            this.filter.cpfcnpj_produtor,
            this.perPage,
            this.currentPage
          )
          .then((resposta) => {
            this.receitas = resposta.data.data
            this.rows = resposta.data.count
            this.isLoading = this.loading(this.show)
          })
          .catch((error) => {
            this.$bvToast.toast(
              error.response ? error.response.data.message : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.receitas = []
            this.rows = 1
            this.isLoading = false
          })
      } else {
        this.listando()
      }
    },
    verifyAndApplyFilters() {
      if (this.filter.numero_receita ||
        this.filter.status ||
        this.filter.data_inicial ||
        this.filter.data_final ||
        (this.produtorSelecionado && this.produtorSelecionado.item) ||
        (this.agronomoSelecionado && this.agronomoSelecionado.item) ||
        this.filter.cpfcnpj_produtor ||
        (this.$store.state.auth.currentUser.user === 'cassul' && this.filter.status !== 'EMITIDA')) {
        this.listandoByFilter();
      } else {
        this.listando();
      }
    },
    normalizeProdutoresResponse(resposta) {
      const payload = resposta && resposta.data ? resposta.data : {}
      const pagination = payload.pagination || {}

      this.produtoresTotalDisponivel = Number(
        pagination.total ||
        payload.total ||
        payload.count ||
        0
      )

      if (Array.isArray(payload.data)) {
        return payload.data
      }

      if (Array.isArray(payload.dados)) {
        return payload.dados
      }

      if (Array.isArray(payload.produtores)) {
        return payload.produtores
      }

      if (Array.isArray(payload)) {
        return payload
      }

      return []
    },
    handleBuscarProdutores(search, loading) {
      const termo = search ? String(search).trim() : ''

      if (this.produtorSearchDebounce) {
        clearTimeout(this.produtorSearchDebounce)
      }

      this.produtorSearchDebounce = setTimeout(() => {
        this.handleConsultarProdutores(termo, loading)
      }, 250)
    },
    getProdutorOptionLabel(item) {
      if (!item) {
        return ''
      }

      return item.endereco
        ? `${item.nome} - Endereço: ${item.endereco}`
        : item.nome || ''
    },
    syncProdutorSelecionadoFromTerm() {
      const termo = this.produtorAutocompleteTerm
        ? String(this.produtorAutocompleteTerm).trim()
        : ''

      if (!termo) {
        this.produtorSelecionado = {}
        return
      }

      const itemEncontrado = this.produtores.find(
        (item) => this.getProdutorOptionLabel(item) === termo
      )

      this.produtorSelecionado = itemEncontrado ? { item: itemEncontrado } : {}
    },
    handleProdutorAutocompleteInput() {
      this.syncProdutorSelecionadoFromTerm()
      if (!this.produtorAutocompleteTerm) {
        this.produtorSelecionado = {}
      }

      this.handleBuscarProdutores(this.produtorAutocompleteTerm)
    },
    handleProdutorAutocompleteFocus() {
      this.handleConsultarProdutores(this.produtorAutocompleteTerm)
    },
    handleSelecionarProdutor(item) {
      this.produtorSelecionado = { item }
      this.produtorAutocompleteTerm = this.getProdutorOptionLabel(item)
    },
    handleConsultarProdutores(search = '', loading = null) {
      const token = this.$store.state.auth.currentUser.token
      this.isLoadingProdutores = true
      if (typeof loading === 'function') {
        loading(true)
      }

      const request = search
        ? produtorRural.listarByFilter(token, search, 1, 20)
        : produtorRural.listar(token, 1, 20)

      request
        .then((resposta) => {
          const items = this.normalizeProdutoresResponse(resposta)

          if (
            this.produtorSelecionado &&
            this.produtorSelecionado.item &&
            this.produtorSelecionado.item.id_produtor_rural &&
            !items.some(
              (item) =>
                item.id_produtor_rural ===
                this.produtorSelecionado.item.id_produtor_rural
            )
          ) {
            this.produtores = [this.produtorSelecionado.item, ...items]
            return
          }

          this.produtores = items
        })
        .catch(() => {
          this.produtores = []
          this.produtoresTotalDisponivel = 0
        })
        .finally(() => {
          this.isLoadingProdutores = false
          if (typeof loading === 'function') {
            loading(false)
          }
        })
    },
    handleConsultarAgronomo() {
      const token = this.$store.state.auth.currentUser.token
      agronomoService
        .listar(token)
        .then((resposta) => {
          this.agronomos = resposta.data.data
        })
    },
    cadastro() {
      this.receita = { id: null }
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listando()
      }
    },
    clearFilters() {
      this.filter = {
        numero_receita: '',
        data_inicial: '',
        data_final: '',
        status: '',
        cpfcnpj_produtor: '',
      }
      this.produtorSelecionado = {}
      this.produtorAutocompleteTerm = ''
      this.agronomoSelecionado = {}
      this.currentPage = 1
      if (this.$store.state.auth.currentUser.user === 'cassul') {
        this.filter.status = 'EMITIDA'
      }
      this.verifyAndApplyFilters()
    },
    modalDelete(receita) {
      // if (receita.status !== 'INICIADA') {
      //   this.$bvToast.toast(
      //     'Não é possível cancelar uma RECEITA com status EMITIDA ou CANCELADA',
      //     {
      //       variant: 'danger',
      //       solid: false,
      //       noCloseButton: true,
      //       toaster: 'b-toaster-top-center',
      //     }
      //   )
      //   return
      // }
      this.showModal = true
      this.idReceita = receita.id
    },
    editarNumeracao(receita) {
      this.showModalEditarNumeracao = true
      this.idReceita = receita.id
      this.novo_numero_receita = receita.numero
      this.nova_nf = receita.nf || ''
      this.nova_serie_nf = receita.serie_nf || ''
      this.novo_valor_nf = receita.valor_nf || ''
    },
    reiniciarReceita(receita) {
      this.showModalReiniciar = true
      this.idReceita = receita.id
    },
    handleDelete() {
      // if (this.$store.state.auth.currentUser.user === 'cassul') {
      //   this.$bvToast.toast('Verifique com o administrador do sistema para realizar o cancelamento desse receituário!',
      //     {
      //       variant: 'warning',
      //       solid: false,
      //       noCloseButton: true,
      //       toaster: 'b-toaster-top-center',
      //     }
      //   )
      //   return
      // }
      this.showModal = false
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.show)
      receitaService
        .deletar(token, this.idReceita)
        .then((resposta) => {
          this.isLoading = this.loading(this.show)
          this.$bvToast.toast('Receita cancelada com sucesso!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.altaEstoqueReceituario(token, this.idReceita)
          this.listando()
          this.idReceita = 0
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = this.loading(this.show)
        })
    },
    handleEditarNumeracao() {
      this.showModalEditarNumeracao = false
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.show)
      receitaService
        .editarNumeracao(token, this.idReceita, {
          numero: this.novo_numero_receita,
          nf: this.nova_nf,
          serie_nf: this.nova_serie_nf,
          valor_nf: this.novo_valor_nf,
        })
        .then((resposta) => {
          this.isLoading = this.loading(this.show)
          this.$bvToast.toast('Numeração editada com sucesso!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.listando()
          this.idReceita = 0
          this.novo_numero_receita = ''
          this.nova_nf = ''
          this.nova_serie_nf = ''
          this.novo_valor_nf = ''
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = this.loading(this.show)
        })
    },
    handleReceiniciarReceita() {
      this.showModalReiniciar = false
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.show)
      receitaService
        .rebuild(token, this.idReceita)
        .then((resposta) => {
          this.isLoading = this.loading(this.show)
          this.$bvToast.toast('Receita reiniciada com sucesso!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.listando()
          this.idReceita = 0
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = this.loading(this.show)
        })
    },

    async altaEstoqueReceituario(token, id) {
      var config = JSON.parse(window.localStorage.getItem('configuracao'))
      if (config.baixa_estoque_receituario) {
        await estoqueService.altaEstoqueReceituario(token, id)
      }
    },

    handleConsultarReceita(receita) {
      if (receita.status !== 'EMITIDA') {
        this.$bvToast.toast(
          'Não é possível visualizar ou imprimir uma RECEITA que não foi EMITIDA',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.show)
      receitaService
        .consultarReceita(token, receita.id)
        .then((resposta) => {
          this.isLoading = this.loading(this.show)
          this.$bvModal.show('rel-receita')
          this.relatorioReceita = resposta.data
          this.relatorioReceita.assinatura = receita.agronomo.digital_signature
          this.relatorioReceita.is_sign_produtor = receita.agronomo.is_sign_prod
          this.relatorioReceita.hash = receita.hash
          this.relatorioReceita.data_hora = receita.data_hora
          this.relatorioReceita.url_pdf = receita.url_pdf
        })
        .catch((error) => {
          this.idReceita = 0
          this.isLoading = this.loading(this.show)
        })
    },
    editReceita(receita) {
      if (receita.status !== 'INICIADA') {
        this.$bvToast.toast(
          'Não é possível editar uma RECEITA com status EMITIDA ou CANCELADA',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
        return
      }
      this.receita = receita
      this.mostraForm = false
    },
    printReceita() {
      this.$root.$emit('print-receita')
    },
    async handleEnviarFaturamentoTorge(receita) {
      const token = this.$store.state.auth.currentUser.token
      const idReceita = receita.id_receita || receita.id

      this.syncingReceitaId = idReceita
      this.isIntegrationLoading = true
      this.integrationLoadingMessage = 'Estamos processando os dados e enviando a receita para a integracao da Torge. Aguarde...'

      try {
        const resposta = await receitaService.enviarFaturamentoTorge(token, idReceita)

        this.$bvToast.toast(
          resposta.data.message || resposta.data.mensagem || 'Receita enviada para faturamento da Torge com sucesso.',
          {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } catch (error) {
        this.$bvToast.toast(
          error.response.data.message || error.response.data.mensagem || 'Não foi possível enviar a receita para faturamento da Torge.',
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } finally {
        this.syncingReceitaId = null
        this.isIntegrationLoading = false
        this.integrationLoadingMessage = ''
      }
    },
    async handleEnviarWebhookSisdev(receita) {
      const token = this.$store.state.auth.currentUser.token
      const nomeProdutor = receita && receita.produtor && receita.produtor.nome
        ? String(receita.produtor.nome).trim()
        : ''

      if (!nomeProdutor) {
        this.$bvToast.toast('Não foi possível identificar o nome do produtor para consultar as credenciais do SISDEV.', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      this.isLoading = this.loading(this.show)

      try {
        const produtorResponse = await produtorRural.listarByFilter(token, nomeProdutor)
        const produtores = Array.isArray(produtorResponse && produtorResponse.data)
          ? produtorResponse.data
          : Array.isArray(produtorResponse && produtorResponse.data && produtorResponse.data.data)
            ? produtorResponse.data.data
            : Array.isArray(produtorResponse && produtorResponse.data && produtorResponse.data.produtores)
              ? produtorResponse.data.produtores
              : []

        const produtorEncontrado = produtores.find((item) => {
          const nomeAtual = item && item.nome ? String(item.nome).trim().toLowerCase() : ''
          return nomeAtual === nomeProdutor.toLowerCase()
        }) || produtores[0]

        const usuarioSisdev = produtorEncontrado && produtorEncontrado.usuario_sisdev
          ? String(produtorEncontrado.usuario_sisdev).trim()
          : ''
        const senhaSisdev = produtorEncontrado && produtorEncontrado.senha_sisdev
          ? String(produtorEncontrado.senha_sisdev).trim()
          : ''

        if (!usuarioSisdev || !senhaSisdev) {
          this.isLoading = false
          this.$bvToast.toast('O produtor não possui usuário_sisdev e senha_sisdev cadastrados.', {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        }

        await receitaService.enviarWebhookSisdev({
          idReceita: receita.id,
          usuario_sisdev: usuarioSisdev,
          senha_sisdev: senhaSisdev,
        })

        this.isLoading = this.loading(this.show)
        this.$bvToast.toast(`Receita ${receita.id} enviada para o webhook SISDEV.`, {
          variant: 'success',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } catch (error) {
        this.isLoading = false
        this.$bvToast.toast('Não foi possível enviar a receita para o webhook SISDEV.', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div>
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="titulo">Receitas</div>
            <div class="subTitulo">Visualize, edite e cadastre novas receitas na plataforma.</div>
          </div>
          <div class="col-md-4">
            <div class="float-md-right receita-header-actions">
              <button v-if="mostraForm" class="btn btn-outline-secondary mr-2" @click="showFilterSidebar = true">
                Filtros
              </button>
              <button class="btn btn-primary" @click="cadastro">
                <span v-if="mostraForm">Nova Receita</span>
                <span v-else>Visualizar Receitas</span>
              </button>
            </div>
          </div>
        </div>
        <div v-if="mostraForm" class="row">
          <div class="col-md-12">
            <div class="borda"></div>
            <div class="row mb-4">
              <div class="col-md-8">
                <div class="description found"><b>Total de Registros: {{ rows }}</b></div>
              </div>
              <div class="col-md-4">
                <div class="float-md-right d-flex align-items-end justify-content-md-end">
                  <div class="mr-3">
                    <b-form-group label="Itens por página" class="mb-0">
                      <b-form-select v-model="perPage" class="numPerPage" :options="pageOptions"></b-form-select>
                    </b-form-group>
                  </div>
                  <button class="btn btn-primary" @click="$refs.btnexport.$el.click()">
                    Exportar Excel
                    <vue-excel-xlsx ref="btnexport" style="display: none" :data="receitasExcel" :columns="columns"
                      :filename="'receitas'" :sheetname="'receitas'">
                    </vue-excel-xlsx>
                  </button>
                </div>
              </div>
            </div>
            <b-table striped hover responsive borderless bordered outlined small :items="receitas"
              :fields="receitaFields" :per-page="perPage">
              <template v-slot:cell(data)="row">
                {{ formatDate(row.item.data) }}
              </template>
              <template v-slot:cell(status)="row">
                <b-badge v-if="row.item.status === 'EMITIDA'" variant="primary" class="pl-2 pr-2 pt-1 pb-1">{{
                row.item.status }}</b-badge>
                <b-badge v-else-if="row.item.status === 'INICIADA'" variant="info" class="pl-2 pr-2 pt-1 pb-1">{{
                row.item.status }}</b-badge>
                <b-badge v-else variant="danger" class="pl-2 pr-2 pt-1 pb-1">{{
                row.item.status
              }}</b-badge>
              </template>
              <template v-slot:cell(actions)="row">
                <div class="btn-group mb-2">
                  <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
                    <template v-slot:button-content>
                      <i class="uil uil-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click="editReceita(row.item)">Editar</b-dropdown-item>
                    <b-dropdown-item @click="handleConsultarReceita(row.item)">Visualizar</b-dropdown-item>
                    <b-dropdown-item @click="modalDelete(row.item)">Cancelar</b-dropdown-item>
                    <b-dropdown-item
                      @click="editarNumeracao(row.item)">Editar numeração</b-dropdown-item>
                    <b-dropdown-item @click="reiniciarReceita(row.item)">Reiniciar receituário</b-dropdown-item>
                    <b-dropdown-item
                      v-if="canSyncTorgeFaturamento"
                      :disabled="syncingReceitaId === (row.item.id_receita || row.item.id)"
                      @click="handleEnviarFaturamentoTorge(row.item)"
                    >
                      {{ syncingReceitaId === (row.item.id_receita || row.item.id) ? 'Enviando...' : 'Enviar faturamento Torge' }}
                    </b-dropdown-item>
                    <b-dropdown-item v-show="$store.state.auth.currentUser.user === 'agrotresestrelas' || $store.state.auth.currentUser.user === 'admin_sistema'" @click="handleEnviarWebhookSisdev(row.item)">Enviar webhook SISDEV</b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="btn-group mb-4">&#8195;&#8195;</div>
              </template>
            </b-table>

            <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"></b-pagination>
          </div>
        </div>
        <div v-else>
          <formEmitirReceita :receita="receita" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal v-model="showModal" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja cancelar a Receita?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showModal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>

    <b-modal id="rel-receita" size="lg" :hide-footer="true" @hidden="listando()">
      <relReceita :receita="relatorioReceita" :empresa="empresa" :is-signature="empresa.is_digital_signature"
        :url-pdf="relatorioReceita.url_pdf" />
      <template v-slot:modal-header>
        <div class="ml-auto">
          <b-button class="mr-2" variant="danger" @click="$bvModal.hide('rel-receita')">Sair</b-button>
          <b-button v-if="relatorioReceita.url_pdf" :href="relatorioReceita.url_pdf" target="_blank"
            variant="success">Ver Receita</b-button>
          <b-button v-else variant="primary" @click="printReceita">Imprimir</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal v-model="showModalEditarNumeracao" title="Editar Numeração" title-class="font-18">
      <div class="col-md-12">
        <b-form-group id="input-group-1" label="Digite o novo número da receita" label-for="input-2">
          <b-form-input v-model="novo_numero_receita" type="text" required></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-nf" label="NF" label-for="input-nf">
          <b-form-input id="input-nf" v-model="nova_nf" type="text"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-serie-nf" label="Série NF" label-for="input-serie-nf">
          <b-form-input id="input-serie-nf" v-model="nova_serie_nf" type="text"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-valor-nf" label="Valor NF" label-for="input-valor-nf">
          <b-form-input id="input-valor-nf" v-model="novo_valor_nf" type="number" step="0.01"></b-form-input>
        </b-form-group>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showModalEditarNumeracao = false">Não</b-button>
        <b-button variant="primary" @click="handleEditarNumeracao">Sim</b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModalReiniciar" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja reiniciar a Receita?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showModalReiniciar = false">Não</b-button>
        <b-button variant="danger" @click="handleReceiniciarReceita">Sim</b-button>
      </template>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap></b-overlay>

    <b-modal
      v-model="isIntegrationLoading"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      body-class="integration-loading-modal-body"
    >
      <div class="integration-loading-content">
        <b-spinner variant="primary"></b-spinner>
        <p class="integration-loading-text">
          {{ integrationLoadingMessage || 'Carregando dados...' }}
        </p>
      </div>
    </b-modal>

    <b-sidebar v-model="showFilterSidebar" right shadow backdrop width="420px" title="Filtros da Receita">
      <div class="filter-sidebar">
        <div class="filter-sidebar-subtitle">
          Defina os filtros da listagem e aplique a pesquisa quando estiver pronto.
        </div>

        <b-form-group id="input-group-1" label="Status" label-for="input-2">
          <v-select v-model="filter.status" class="style-select" label="descricao" :options="status"
            :reduce="(stat) => stat.status" :dense="true"></v-select>
        </b-form-group>

        <b-form-group id="input-group-1" label="Número da receita" label-for="input-2">
          <b-form-input v-model="filter.numero_receita" type="text" required></b-form-input>
        </b-form-group>

        <b-form-group id="input-cpfcnpjprodutor" label="CPF/CNPJ Produtor" label-for="filter">
          <b-form-input v-model="filter.cpfcnpj_produtor" v-mask="['###.###.###-##', '##.###.###/####-##']"
            type="text" required></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-1" label="Produtores" label-for="filter">
          <b-form-input
            v-model="produtorAutocompleteTerm"
            list="receita-produtores-autocomplete"
            autocomplete="off"
            placeholder="Digite para buscar produtores"
            @input="handleProdutorAutocompleteInput"
            @change="syncProdutorSelecionadoFromTerm"
            @focus="handleProdutorAutocompleteFocus"
          />
          <b-form-datalist
            id="receita-produtores-autocomplete"
            :options="produtorAutocompleteOptions"
          />
        </b-form-group>

        <b-form-group id="input-group-1" label="Agrônomos" label-for="filter">
          <v-select v-model="agronomoSelecionado.item" class="style-select" label="nome" :options="agronomos"
            :reduce="(item) => item" :dense="true"></v-select>
        </b-form-group>

        <b-form-group id="input-group-1" label="Data inicial" label-for="input-2">
          <b-form-datepicker id="datepicker-inicial" v-model="filter.data_inicial"
            placeholder="Selecione a data inicial" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="pt-br">
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </b-form-group>

        <b-form-group id="input-group-1" label="Data final" label-for="input-2">
          <b-form-datepicker id="datepicker-final" v-model="filter.data_final"
            placeholder="Selecione a data final" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="pt-br">
            <template v-slot:button-content>
              <b-icon icon="calendar" variant="primary"></b-icon>
            </template>
          </b-form-datepicker>
        </b-form-group>

        <div class="filter-sidebar-actions">
          <button class="btn btn-outline-secondary mr-2" @click="clearFilters">Limpar</button>
          <button class="btn btn-primary" @click="listandoByFilter(); showFilterSidebar = false">Pesquisar</button>
        </div>
      </div>
    </b-sidebar>
  </Layout>
</template>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Dancing+Script');

.sig3 {
  font-family: 'Dancing Script';
  font-size: 1.9em;
}

.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subTitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .table-responsive {
    overflow: visible;
  }

  .dropdown-menu {
    z-index: 2000;
  }
}

.receita-header-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.integration-loading-modal-body {
  padding: 32px 24px;
}

.integration-loading-content {
  display: flex;
  max-width: 360px;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.integration-loading-text {
  margin-top: 12px;
  margin-bottom: 0;
  color: #334155;
  font-weight: 500;
  line-height: 1.4;
}

.filter-sidebar {
  padding: 8px 6px 24px;
}

.filter-sidebar-subtitle {
  margin-bottom: 16px;
  color: #5f7380;
  font-size: 13px;
}

.filter-sidebar-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

@media (max-width: 991px) {
  .bloco {
    padding: 22px;
  }

  .bloco .titulo {
    font-size: 24px;
  }

  .receita-header-actions {
    margin-top: 20px;
    justify-content: flex-start;
  }

  .receita-header-actions .btn {
    margin-bottom: 8px;
  }
}
</style>
